import { render, staticRenderFns } from "./BtnUploadStats.vue?vue&type=template&id=471ca7b0&v-slot%3Aextension=true&"
import script from "./BtnUploadStats.vue?vue&type=script&lang=js&"
export * from "./BtnUploadStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports